import React from "react";
import { useNavigate } from "react-router-dom";

import "./header.css"
  

function Header(props) {
  
const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate("/");
  };

return (
<>
  <header>
    <div className="container-lg d-flex align-items-center justify-content-between position-relative">
      <div className="d-flex align-items-center header-logo">
        <a href="/" onClick={handleClick}>
          <img src="dist/img/icici_logo.webp" alt="ICICI Bank Logo" width="252" height="50" className="img-fluid" />
        </a>
      </div>
    </div>
  </header>
</>
);
}

export default Header;